export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('INDEX.evg_sku_label_fabricName') || '面料名称',
    field: 'fabricName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    field: 'fabricStatus',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('INDEX.evg_sku_label_fabricColor') || '颜色克重',
    field: 'fabricColor',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabricColor' },
  },
  {
    title: that.$l('INDEX.evg_sku_label_fabricContent') || '面料成分',
    field: 'fabricContent',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabricContent' },
  },
  {
    title: that.$l('INDEX.evg_sku_label_fabricAgentCode') || '业务开发',
    field: 'fabricAgentName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.evg_sku_label_unit_Price') || '单价',
    field: 'unitPrice',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'unitPrice' },
  },
  {
    title: that.$l('INDEX.evg_sku_label_scmName') || '面料工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.evg_sku_label_factoryNumber') || '工厂面料编号',
    field: 'factoryNumber',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.creator') || '创建人',
    field: 'createByName',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
